function getConfig() {
  return new Promise((resolve) => {
    fetch('/api/config').then((resp) => {
      resp.json().then((config) => {
        resolve(config)
      })
    })
  })
}

export default getConfig
